<template>
  <div id="CODealerHospitalSearch">
    <section>
      <div id="container-center">
        <div class="labelTitle lable">ケア オーケストレーター施設検索</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>医療機関名</th>
              <td><input type="text" v-model="searchConditions.hospitalName"/></td>
              <th>郵便番号</th>
              <td><input type="text" v-model="searchConditions.postCode"/></td>
              <th>クライアント認証状態</th>
              <td>
                <select
                    v-model="searchConditions.certificateStatus">
                    <option :value="0"></option>
                    <option :value="1">{{ "有効" }}</option>
                    <option :value="2">{{ "無効" }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <div>
            <b-table
              :data="data"
              :paginated="true"
              per-page="10"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="医療機関名" label="医療機関名" width="400" class="breakAll">
                  <router-link :to="{name:'CODealerSettingHospital', params:{searchConditions:searchConditions,careOrchestratorInstitutionId:props.row.careOrchestratorInstitutionId, certificationFlag:props.row.certificationFlag}}"><a>{{props.row.medicalInstitutionName}}</a></router-link>
                </b-table-column>
                <b-table-column field="郵便番号" label="郵便番号" width="100" centered>{{props.row.postcode}}</b-table-column>
                <b-table-column field="住所" label="住所" class="breakAll">{{props.row.prefecture}}{{props.row.city}}{{props.row.address1}}{{props.row.address2}}</b-table-column>
                <b-table-column field="クライアント認証状態" label="クライアント認証状態" class="breakAll">{{props.row.certificationFlag?"有効":"無効"}}</b-table-column>
              </template>
            </b-table>
          </div>
        </div>
        <div style="margin-top:10px;">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "CODealerHospitalSearch",
  methods: {
    back: function() {
      this.$router.push({ path: "/guest/careorchestrator/CODealerMenu" });
    },
    doSearch: function() {
      var excuteApi = this.getCoInstitutionListPOST;
      var successCallBack = this.getCoInstitutionListPOSTSuccess;
      var errorCallBack = this.getCoInstitutionListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCoInstitutionListPOST: function(client) {
      console.log(this.searchConditions)
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.belongsId = this.belongsId
      return client.apis.externalCODealer.getCoInstitutionListPOST({
        body:obj
      });
    },
    getCoInstitutionListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getCoInstitutionListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var searchConditions = this.$route.params["searchConditions"];
    if(!searchConditions){
      searchConditions = {};
    }
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      searchConditions: searchConditions,
      data: [],
      isPaginated: true,
      belongsId:userInfo.belongsId
    };
  },
  filters: {},
  components: {},
  async mounted() {
    if(this.searchConditions.hospitalName != undefined){
      await this.doSearch();
    } else {
      this.searchConditions = {hospitalName:"",postCode:"",certificateStatus:""}
    }
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CODealerHospitalSearch.vue